import { LegendSwatch } from "@/shared/components/legend-swatch";
import type { LegendaSimuladoViewModel } from "./types-legenda-simulado";

export function LegendaSimuladoView({ className, amostra, rotulo }: LegendaSimuladoViewModel) {
  return (
    <li className={className} data-testid="legenda-simulado">
      <LegendSwatch kind={amostra} />
      {rotulo}
    </li>
  );
}
